import { atom } from 'recoil';

import { CURRENT_TAB } from 'store/constants';

export const ACurrentTab = atom<string>({
  key: CURRENT_TAB,
  default: 'game',
});
